import { Component, OnInit, Inject, SimpleChanges, OnChanges } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/shared/services/api.service';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { Router } from '@angular/router';
import { MatProgressButtonOptions } from 'mat-progress-buttons';
import { isTokenExpiryEnabled, logoutUser } from 'src/app/theme/utils/feature-tag';

@Component({
  selector: 'app-delete-cart',
  templateUrl: './delete-cart.component.html',
  styleUrls: ['./delete-cart.component.scss']
})
export class DeleteCartComponent implements OnInit, OnChanges {
  localStorageCartProd;
  url = this.router.url.split('?')[0];
  selectedDeliveryCalendar= {};
  cutOffTime = [];
  deleteCartButtonOptions: MatProgressButtonOptions = {
    active: false,
    text: 'Delete',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate'
  }
  loggedIn = false;
  featureTags = {};
  constructor(@Inject(MAT_DIALOG_DATA) public product: any, public dialogRef: MatDialogRef<DeleteCartComponent>,
  private apiService: ApiService, private subscription: SubscriptionService,
  private notification: NotificationService, private router: Router) { }

  ngOnChanges(changes: SimpleChanges) {
    // console.log('Categories changed:', changes);
}

  ngOnInit() {    
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
    
    let delivery_date = sessionStorage.getItem('selected_delivery_date');
    let deliveryCalendar = JSON.parse(sessionStorage.getItem('event_details'));

    // Find the selected delivery date object from the deliveryCalendar array
    if (deliveryCalendar && Array.isArray(deliveryCalendar)) {
      this.selectedDeliveryCalendar = deliveryCalendar.find(
            (event: any) => event.event_date === delivery_date
        ) || {};
    }
    this.cutOffTime = JSON.parse(sessionStorage.getItem('cutoff')); 
    this.localStorageCartProd = JSON.parse(sessionStorage.getItem('cart'));
    this.loggedIn = this.apiService.loggedIn();
    if(this.product['isLastProduct'] && this.loggedIn === true && !!this.selectedDeliveryCalendar) {
      this.deleteCartButtonOptions.text = "Yes";
    }
  }
  delete(msg) {
    if(msg === 'single') {
      if(this.apiService.loggedIn()) {
        this.deleteCartButtonOptions.active = true;
        var value = {
          cart_product_id: this.product['id']
        }
        // if( (this.selectedDeliveryCalendar !== null && this.selectedDeliveryCalendar['sale_orders'] !== null && this.selectedDeliveryCalendar['sale_orders'].includes("undelivered")
        // && this.selectedDeliveryCalendar['create_order'] === true) && (this.cutOffTime !== null && this.cutOffTime[0]['orderDeliveryDate'] !== this.cutOffTime[0]['storeDeliveryDate'] || 
        // this.cutOffTime[0]['orderDeliveryDate'] === this.cutOffTime[0]['storeDeliveryDate'] && this.cutOffTime[0]['currentDateAndtime'] < this.cutOffTime[0]['storeCutOffTime'])) {
          var data = {
            sale_product_id: this.product['id']
          }
          this.apiService.deleteSaleProduct(data).subscribe(result => {
            this.deleteCartButtonOptions.active = false;
            if(result['response']['status'] === 1) {
              this.dialogRef.close({value: 'delete', product: this.product});
            } else if (result['response']['status'] === 22) {
              // For logged out user from server
              if (isTokenExpiryEnabled(this.featureTags)) {
                this.dialogRef.close({value: '', product: ''});
                logoutUser(this.apiService, this.router, this.notification)
              }
            } else {
              this.notification.warning(result['response']['message'], 5000);
              //this.dialogRef.close({value: '', product: ''});
            }
          }, (error) => {
            this.deleteCartButtonOptions.active = false;
            if(error) {
              console.log(error);
            }
          });
        // } else  {
        //   if(this.product['isLastProduct'] && !!this.selectedDeliveryCalendar) {
        //     this.deleteScheduledOrder();
        //   } else {
        //     this.apiService.deleteCart(value).subscribe(result => {
        //       this.deleteCartButtonOptions.active = false;
        //       if(result['response']['status'] === 1) {
        //         this.dialogRef.close({value: 'delete', product: this.product});
        //       } else {
        //         this.notification.warning(result['response']['message'], 5000);
        //         //this.dialogRef.close({value: '', product: ''});
        //       }
        //     }, (error) => {
        //       this.deleteCartButtonOptions.active = false;
        //       if(error) {
        //         console.log(error);
        //       }
        //     });
        //   }
         
        // }
      } else {
        this.dialogRef.close({value: 'delete', product: this.product});
        this.localStorageCartProd = this.localStorageCartProd.filter(val => {
          return val['product']['id'] !== this.product['product']['id']
        });
        sessionStorage.setItem('cart',  JSON.stringify(this.localStorageCartProd));
        this.subscription.subjectNext({cartlength: this.localStorageCartProd.length, control: 'Edit too add', product: this.product})
      }
    }
    if(msg === 'all') {
      if(this.apiService.loggedIn()) {
        this.apiService.deleteAllCart().subscribe(result => {
          if(result['response']['status'] === 1) {
            this.dialogRef.close({value: 'delete'});  
            this.notification.error('Your Cart has been successfully emptied!', 5000);
          }else  {
            this.notification.success(result['response']['message'], 5000);
          }
        }, (error) => {
          if(error) {
            console.log(error);
          }
        });
      } else {
        this.dialogRef.close({value: 'delete'});
        localStorage.clear();
      }      
    }
  }
  deleteScheduledOrder() {
    var values = {};
    values =  [{
      recurring_id: 0,
      product_id: this.product['product']['id'],  
      quantity: this.product['quantity'],  
      frequency: this.product['frequency'], 
      is_recurring: 0
    }]
    this.apiService.cancelScheduledOrder({items: values}).subscribe(result => {
      this.deleteCartButtonOptions.active = true;
      if(result['response']['status'] === 1) {
        this.subscription.subjectNext({msg:"set delivery calendar order status", status: "cancelled"});
        this.dialogRef.close({message: 'delete scheduled order', deleted:1 , status:1, value: 'delete'});
        if(!!this.featureTags && this.featureTags['warning_for_the_user_to_save_the_order'] === true){
            this.clearCart(); //this is to clear the cart when the last item is deleted 
        }
      }
    });
  }
  clearCart() {
    const emptyCart: any[] = [];
    sessionStorage.setItem('cart', JSON.stringify(emptyCart)); // Store empty array in session storage
  }      
}
